/* eslint-disable class-methods-use-this */

// Storage abstraction for authority optic selection
// This makes it easy to swap localStorage for another storage mechanism later

const FAVORITE_STORAGE_KEY = 'favorite-authority-optic-id';
const ACTIVE_STORAGE_KEY = 'active-authority-optic-id';

export interface IAuthorityOpticStorage {
  getFavoriteOpticId(): string | undefined;
  setFavoriteOpticId(opticId: string): void;
  clearFavoriteOpticId(): void;
  getActiveOpticId(): string | undefined;
  setActiveOpticId(opticId: string): void;
}

class LocalStorageAuthorityOpticStorage implements IAuthorityOpticStorage {
  getFavoriteOpticId(): string | undefined {
    const value = localStorage.getItem(FAVORITE_STORAGE_KEY);
    return value ?? undefined;
  }

  setFavoriteOpticId(opticId: string): void {
    localStorage.setItem(FAVORITE_STORAGE_KEY, opticId);
  }

  clearFavoriteOpticId(): void {
    localStorage.removeItem(FAVORITE_STORAGE_KEY);
  }

  getActiveOpticId(): string | undefined {
    const value = sessionStorage.getItem(ACTIVE_STORAGE_KEY);
    return value ?? undefined;
  }

  setActiveOpticId(opticId: string): void {
    sessionStorage.setItem(ACTIVE_STORAGE_KEY, opticId);
  }
}

// Export a singleton instance
// To swap storage mechanism, just change this implementation
export const authorityOpticStorage: IAuthorityOpticStorage = new LocalStorageAuthorityOpticStorage();
